<template>
  <div>
  <div class="py-6 px-4 pb-24 space-y-4" dir="rtl">
    <div class="max-w-2xl mx-auto space-y-4">
      
      <!-- Header -->
      <div class="bg-gradient-to-r from-blue-600 to-blue-700 rounded-2xl p-6 text-white">
        <h1 class="text-2xl font-bold mb-2">جزئیات درخواست</h1>
        <p class="text-blue-100 text-sm">اطلاعات تکمیلی درخواست را وارد کنید</p>
      </div>

      <!-- Phone Number Input -->
      <div class="bg-white rounded-2xl border border-gray-200 p-6">
        <label class="block text-sm font-bold text-gray-700 mb-3">{{ $t('phoneNoNotReq') }}</label>
        <div class="grid grid-cols-3 gap-3">
          <div class="col-span-2">
            <input
              type="tel"
              inputmode="numeric"
              pattern="[0-9]*"
              v-model="other_number"
              class="w-full px-4 py-3 border border-gray-400 rounded-md text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              placeholder="09123456789"
              style="border: 1px solid rgb(209, 213, 219) !important;"
            />
          </div>
          <div class="relative">
            <select 
              v-model="selected_phone_code"
              style="border: 1px solid rgb(209, 213, 219) !important;"
              class="w-full pr-4 pl-9  py-3 border border-gray-400 rounded-md text-gray-900 font-medium focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 appearance-none bg-white"
            >
              <option 
                v-for="item in phone_code_items"
                dir="ltr"
                
                :key="item.value"
                :value="item.value"
              >
                {{ item.label }}
              </option>
            </select>
            <div class="absolute left-2 top-1/2 -translate-y-1/2 pointer-events-none">
              <svg class="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
              </svg>
            </div>
          </div>
        </div>
      </div>

      <!-- Device Status -->
      <div class="bg-white rounded-2xl border border-gray-200 p-6">
        <label class="block text-sm font-bold text-gray-700 mb-3">{{ $t('deviceStatus') }}</label>
        <div class="relative">
          <select 
            v-model="selected_device_status"
            style="border: 1px solid rgb(209, 213, 219) !important;"
            class="w-full px-4 py-3 border border-gray-400 rounded-md text-gray-900 font-medium focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 appearance-none bg-white"
          >
            <option 
              v-for="item in device_status_items"
              :key="item.value"
              :value="item.value"
            >
              {{ item.label }}
            </option>
          </select>
          <div class="absolute left-4 top-1/2 -translate-y-1/2 pointer-events-none">
            <svg class="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
            </svg>
          </div>
        </div>
      </div>

      <!-- Send From Other City Switch -->
      <div v-if="enable_send_from_country" class="bg-white rounded-2xl border border-gray-200 p-6">
        <div class="flex items-center justify-between gap-4">
          <div class="flex items-center gap-3 flex-1 min-w-0">
            <div class="w-10 h-10 rounded-lg bg-blue-100 flex items-center justify-center">
              <svg class="w-5 h-5 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
              </svg>
            </div>
            <div class="w-full">
              <p class="text-sm font-bold text-gray-900 truncate">{{ $t('sendFromOtherCity') }}</p>
            </div>
          </div>
          <label class="tw-switch flex-shrink-0">
            <input
              type="checkbox"
              v-model="send_from_country"
              class="tw-switch-input"
            >
            <span class="tw-switch-track tw-switch-track--blue"></span>
          </label>
        </div>
      </div>

      <!-- Province and City (if send from country) -->
      <div v-if="send_from_country && enable_send_from_country" class="bg-white rounded-2xl border border-gray-200 p-6">
        <div class="grid grid-cols-2 gap-4">
          <div>
            <label class="block text-sm font-bold text-gray-700 mb-3">استان</label>
            <div class="relative">
              <select 
              style="border: 1px solid rgb(209, 213, 219) !important;"
                v-model="selected_province"
                class="w-full px-4 py-3 border border-gray-400 rounded-md text-gray-900 font-medium focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 appearance-none bg-white"
              >
                <option 
                  v-for="item in province_items"
                  :key="item.value"
                  :value="item.value"
                >
                  {{ item.label }}
                </option>
              </select>
              <div class="absolute left-4 top-1/2 -translate-y-1/2 pointer-events-none">
                <svg class="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                </svg>
              </div>
            </div>
          </div>
          <div>
            <label class="block text-sm font-bold text-gray-700 mb-3">شهر</label>
            <div class="relative">
              <select 
              style="border: 1px solid rgb(209, 213, 219) !important;"
                v-model="selected_city"
                class="w-full px-4 py-3 border border-gray-400 rounded-md text-gray-900 font-medium focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 appearance-none bg-white"
              >
                <option 
                  v-for="item in city_items"
                  :key="item.value"
                  :value="item.value"
                >
                  {{ item.label }}
                </option>
              </select>
              <div class="absolute left-4 top-1/2 -translate-y-1/2 pointer-events-none">
                <svg class="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
                </svg>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Textareas -->
      <div class="bg-white rounded-2xl border border-gray-200 p-6">
        <div class="space-y-4">
          <div>
            <label class="block text-sm font-bold text-gray-700 mb-3">{{ $t('expertDesc') }}</label>
            <textarea
            style="border: 1px solid rgb(209, 213, 219) !important;"
              v-model="technician_summary"
              rows="3"
              class="w-full px-4 py-3 border border-gray-400 rounded-md text-gray-900 focus:outline-none focus:ring-blue-500 focus:border-blue-500 resize-none"
              :placeholder="$t('expertDesc')"
            ></textarea>
          </div>
          <div>
            <label class="block text-sm font-bold text-gray-700 mb-3">{{ $t('appearenceProblem') }}</label>
            <textarea
            style="border: 1px solid rgb(209, 213, 219) !important;"
              v-model="device_appearence"
              rows="3"
              class="w-full px-4 py-3 border border-gray-400 rounded-md text-gray-900 focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-blue-500 resize-none"
              :placeholder="$t('appearenceProblem')"
            ></textarea>
          </div>
          <div>
            <label class="block text-sm font-bold text-gray-700 mb-3">{{ $t('customerDesc') }}</label>
            <textarea
            style="border: 1px solid rgb(209, 213, 219) !important;"
              v-model="customer_summary"
              rows="3"
              class="w-full px-4 py-3 border border-gray-400 rounded-md text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 resize-none"
              :placeholder="$t('customerDesc')"
            ></textarea>
          </div>
        </div>
      </div>

      <!-- Submit Button -->
      <button 
        @click="go_to_categories()"
        class="w-full py-4 bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white font-bold rounded-2xl hover:shadow-xl transition-all duration-200"
      >
        {{ $t('sendInformation') }}
      </button>

    </div>
  </div>

  <!-- Success Modal -->
  <div v-if="show_success_modal" class="fixed inset-0 z-999">
    <div class="absolute inset-0 bg-black bg-opacity-60"></div>
    <div class="relative z-10 flex h-full w-full items-center justify-center p-4">
      <div class="w-full max-w-md bg-white border border-green-300 rounded-2xl shadow-xl overflow-hidden">
        <div class="bg-gradient-to-r from-green-500 to-green-600 px-6 py-8 text-center">
          <div class="w-20 h-20 bg-white rounded-full flex items-center justify-center mx-auto mb-4">
            <svg class="w-12 h-12 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
            </svg>
          </div>
          <h2 class="text-2xl font-bold text-white mb-2">موفقیت آمیز</h2>
        </div>
        <div class="px-6 py-6 text-center space-y-4">
          <p class="text-gray-900 text-lg">{{ success_message }}</p>
          
          <!-- Request Code Display -->
          <div v-if="req_code" class="bg-gray-50 rounded-lg p-4 border-2 border-green-200">
            <p class="text-sm font-medium text-gray-700 mb-2">شماره درخواست:</p>
            <div class="flex items-center justify-center gap-3">
              <p class="w-full  text-2xl font-bold text-green-600 tracking-wider font-mono text-center">
                <span v-if="!req_code.startsWith('R')">R</span>{{ req_code }}
              </p>
              <button
                @click="copy_request_code()"
                class="p-2 bg-green-100 hover:bg-green-200 rounded-lg transition-colors duration-200 flex items-center justify-center flex-shrink-0"
                title="کپی کردن شماره درخواست"
              >
                <svg class="w-5 h-5 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z" />
                </svg>
              </button>
            </div>
          </div>
          
          <!-- Next Button -->
          <button 
            @click="go_to_attachment()"
            class="w-full bg-gradient-to-r from-green-600 to-green-700 hover:from-green-700 hover:to-green-800 text-white py-4 px-6 rounded-xl font-bold transition-all duration-200 flex items-center justify-center gap-2 mt-4"
          >
            افزودن عکس/ویدئو
            <svg class="w-5 h-5 rotate-180" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 7l5 5m0 0l-5 5m5-5H6" />
            </svg>
          </button>
        </div>
      </div>
    </div>
  </div>
  </div>
</template>
<script>
  import { bus } from '../../main.js'

  export default {
    props: [
      'passing_data'
    ],
    data () {
      return {
        rarely_details: '',
        errors: [],
        phone_code_items: [],
        selected_phone_code: 1,
        other_number: '',

        device_status_items: [],
        selected_device_status: 0,
        province_items: [],
        selected_province: 0,

        city_items: [],
        selected_city: 0,

        send_from_country: false,

        technician_summary: '',
        device_appearence: '',
        enable_send_from_country: false,
        customer_summary: '',
        valid: true,
        not_register: false,
        user_registered: false,
        show_success_modal: false,
        success_message: '',
        req_code: '',
        req_id: 0,

      }
    },
watch: {
      selected_province: function () {
        this.get_cities()
      }
    },
mounted () {
      var passing_data = JSON.parse(localStorage.getItem('request_data'))
      // console.log("response", passing_data.ServiceOutBranchOnFinalize);

      this.enable_send_from_country = !passing_data.on_site_service
      if (passing_data.customer_summary != null) {
        this.customer_summary = passing_data.customer_summary
      }

      if (passing_data.other_phone_code != null) {
        this.selected_phone_code = passing_data.other_phone_code
      }
      if (passing_data.other_phone_no != null) {
        this.other_number = passing_data.other_phone_no
      }
      this.get_phone_prefix()
      this.get_device_status()
      this.get_provinces()
    },
    methods: {
      close_success_modal() {
        this.show_success_modal = false;
      },
      login () {
        var self = this

        const send_data = this.get_bind_data()
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/AddRequestReceipt', send_data, {})
          .then(response => {
            if (response.data.error == 0) {
              console.log('response', response)

              // Show success modal with request code
              self.success_message = response.data.msg
              self.req_code = response.data.ReqCode || ''
              self.req_id = response.data.ReqId || 0
              self.show_success_modal = true
              
              // Modal will not auto-close - user must click button to proceed
            } else {
              bus.$emit('show_toast', [1500, response.data.msg])
            }
            // this.$router.push({ path: "/post-login", params: {} });
          }).catch(e => {
          this.errors.push(e)
        })
      },
      go_to_attachment () {
        this.show_success_modal = false
        setTimeout(() => {
          this.$router.push({ name: 'attachment', params: { rec_id: this.req_id } })
        }, 300)
      },
      copy_request_code () {
        if (this.req_code) {
          // آماده کردن شماره درخواست با R
          let codeToCopy = this.req_code
          if (!codeToCopy.startsWith('R')) {
            codeToCopy = 'R' + codeToCopy
          }
          
          // Create a temporary textarea element
          const textarea = document.createElement('textarea')
          textarea.value = codeToCopy
          textarea.style.position = 'fixed'
          textarea.style.opacity = '0'
          document.body.appendChild(textarea)
          textarea.select()
          textarea.setSelectionRange(0, 99999) // For mobile devices
          
          try {
            // Copy the text
            document.execCommand('copy')
            bus.$emit('show_toast', [2000, 'شماره درخواست کپی شد'])
          } catch (err) {
            // Fallback for modern browsers
            if (navigator.clipboard && navigator.clipboard.writeText) {
              navigator.clipboard.writeText(codeToCopy).then(() => {
                bus.$emit('show_toast', [2000, 'شماره درخواست کپی شد'])
              }).catch(() => {
                bus.$emit('show_toast', [2000, 'خطا در کپی کردن'])
              })
            } else {
              bus.$emit('show_toast', [2000, 'خطا در کپی کردن'])
            }
          }
          
          // Remove the temporary element
          document.body.removeChild(textarea)
        }
      },

      preRequestToRequest () {
        var self = this

        const send_data = this.get_bind_data()
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/PreRequestToRequest', send_data, {})
          .then(response => {
            if (response.data.error == 0) {
              console.log('response', response)

              var request_data = JSON.parse(localStorage.getItem('request_data'))

              if (request_data.ServiceOutBranchOnFinalize != null && request_data.ServiceOutBranchOnFinalize != '0') {
                self.submit_service_out_branch(response.data.ReqId, request_data.ServiceOutBranchOnFinalize, response)
              } else {
                // نمایش مودال موفقیت با شماره درخواست
                self.success_message = 'درخواست با موفقیت ثبت شد'
                self.req_code = response.data.ReqCode || ''
                self.req_id = response.data.ReqId || 0
                self.show_success_modal = true
              }
            } else {
              bus.$emit('show_toast', [1500, response.data.msg])
            }
            // this.$router.push({ path: "/post-login", params: {} });
          }).catch(e => {
          this.errors.push(e)
        })
      },
      submit_service_out_branch (rec_id, status, res) {
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId

        const send_data = {
          UserId: user_id,
          ReqId: rec_id,
          Desc: '',
          StatusId: status,
        }

        // this.axios.post('/Register' , send_data,{
        this.axios.post('/ChangeRequestRefer', send_data, {})
          .then(response => {
            if (response.data.error == 0) {
              console.log('response', response)

              // نمایش مودال موفقیت با شماره درخواست
              self.success_message = 'درخواست با موفقیت ثبت شد'
              self.req_code = res.data.ReqCode || ''
              self.req_id = rec_id || 0
              self.show_success_modal = true
            } else {
              bus.$emit('show_toast', [1500, response.data.msg])
            }
            // this.$router.push({ path: "/post-login", params: {} });
          }).catch(e => {
          this.errors.push(e)
        })
      },
      get_bind_data () {
        var request_id = 0

        var request_data = JSON.parse(localStorage.getItem('request_data'))
        if (request_data.PreRequestId != null) {
          request_id = request_data.PreRequestId
        }
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        var pre_defined_array = []
        var pre_defined = JSON.parse(request_data.pre_defined)

        pre_defined.forEach(function (number) {
          if (number.PredefineTypeId == 1 && number.IsChecked) {
            var pre_obj = {
              TextId: number.TextId,
              Text: '',
              PreDefineTypeId: number.PredefineTypeId,
              CurrencyId: 0
            }
            pre_defined_array.push(pre_obj)
          }
          if (number.PredefineTypeId == 2 && number.Value != null) {
            var pre_obj = {
              TextId: number.TextId,
              Text: number.Value,
              PreDefineTypeId: number.PredefineTypeId,
              CurrencyId: 0
            }
            pre_defined_array.push(pre_obj)
          }
        })

        const send_data = {

          CheckBoxes: pre_defined_array,

          RequestName: request_data.request_name + ' ' + request_data.device_model,

          BranchId: request_data.branch_id,
          ExpertId: user_id, //
          DevicePassword: request_data.device_password, //
          CustomerPhone: request_data.customer_mobile, //
          DevicePattern: '', //
          CustomerName: request_data.customer_name, //
          ExpertOpinion: this.technician_summary, //
          AppearanceProblem: this.device_appearence, //
          RequestDescription: this.customer_summary, //
          ModelId: request_data.device_model_id, //
          ModelTitle: request_data.device_model, //
          CityId: 0, //
          ServiceOutBranch: this.send_from_country, //
          PhoneCode: this.selected_phone_code, //
          PhoneNo: this.other_number, //
          CurrentStatus: this.selected_device_status, //
          Id: 0, //
          PreRequestId: request_id, //
          ProductTypeId: request_data.cat_id, //
          CategoryId: request_data.group_id, //
          GroupId: request_data.sub_group_id, //
          SubGroupId: request_data.brand_id, //
          CurrencyId: request_data.currency,
          PriceRange: request_data.price,
          OnSiteService: request_data.on_site_service,
          DeliveryDay: request_data.tamir_days,
          DeliveryDate: '',

        }
        if (this.send_from_country) {
          send_data.CityId = this.selected_city
        }
        send_data.LegalTitle = request_data.LegalTitle || ''
        send_data.NationalID = request_data.NationalID || ''
        return send_data
      },
      go_to_categories () {
        if (this.technician_summary == '' || this.device_appearence == '' || this.customer_summary == '') {
          bus.$emit('show_toast', [1500, this.$t('fillAllFields')])

          return false
        }
        if (this.selected_device_status == 0) {
          bus.$emit('show_toast', [1500, this.$t('selectDeviceStatus')])

          return false
        }

        var request_data = JSON.parse(localStorage.getItem('request_data'))
        if (request_data.stateId == null) {
          this.login()
        } else if (request_data.stateId == 'final_pre_request') {
          this.preRequestToRequest()
        }
      },
      get_phone_prefix () {
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        console.log()
        const send_data = {
          UserId: user_id,
        }
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/GetPhonePrefixList', send_data, {})
          .then(response => {
            response.data.forEach(function (number) {
              var obj = { value: number.Id, label: number.Code }
              self.phone_code_items.push(obj)
            })
          }).catch(e => {
          this.errors.push(e)
        })
      },
      get_device_status () {
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        console.log()
        const send_data = {
          UserId: user_id,
        }
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/GetReqCurrentStatus', send_data, {})
          .then(response => {
            var obj = { value: 0, label: self.$t('select') }
            self.device_status_items.push(obj)
            response.data.forEach(function (number) {
              var obj = { value: number.RecId, label: number.RecTitle }
              self.device_status_items.push(obj)
            })
          }).catch(e => {
          this.errors.push(e)
        })
      },
      get_provinces () {
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        console.log()
        const send_data = {
          UserId: user_id,
        }
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/GetProvincies', send_data, {})
          .then(response => {
            response.data.forEach(function (number) {
              if (number.ProvinceName == 'تهران') {
                self.selected_province = number.ProvinceId
              }
              var obj = { value: number.ProvinceId, label: number.ProvinceName }
              self.province_items.push(obj)
            })
          }).catch(e => {
          this.errors.push(e)
        })
      },
      get_cities () {
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        console.log()
        const send_data = {
          PId: this.selected_province,
        }
        //所在 this.axios.post('/Register' , send_data,{
        this.axios.post('/GetCitiesByProvinceId', send_data, {})
          .then(response => {
            self.city_items = []
            self.selected_city = response.data.cities[0].CityId
            response.data.cities.forEach(function (number) {
              if (number.CityName == self.$t('selectedAddressCityCurrent')) {
                self.selected_city = number.CityId
              }
              var obj = { value: number.CityId, label: number.CityName }
              self.city_items.push(obj)
            })
          }).catch(e => {
          this.errors.push(e)
        })
      },
    }
  }
</script>
<style scoped>
.tw-switch {
  position: relative;
  display: inline-flex;
  align-items: center;
  cursor: pointer;
}
.tw-switch-input {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
}
.tw-switch-track {
  width: 3rem;
  height: 1.75rem;
  display: inline-block;
  border-radius: 9999px;
  background-color: #e5e7eb;
  position: relative;
  transition: background-color 0.2s;
}
.tw-switch-track::after {
  content: '';
  position: absolute;
  top: 0.25rem;
  left: 3px;
  width: 1.25rem;
  height: 1.25rem;
  background: #fff;
  border: 1px solid #d1d5db;
  border-radius: 9999px;
  transition: transform 0.2s;
}
.tw-switch-input:focus + .tw-switch-track {
  box-shadow: 0 0 0 4px rgba(147, 197, 253, 0.5);
}
.tw-switch-input:checked + .tw-switch-track--blue {
  background-color: #2563eb;
}
.tw-switch-input:checked + .tw-switch-track::after {
  transform: translateX(100%);
  border-color: #fff;
}
</style>
